
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astro/horoscope",
      function () {
        return require("private-next-pages/astro/horoscope/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astro/horoscope"])
      });
    }
  